<template>
  <van-swipe :autoplay="3000" indicator-color="white" class="banner">
    <van-swipe-item v-for="item in banners" :key="item.id">
      <a
        :href="item.link"
        :style="'background:url('+item.code+') no-repeat;background-size: 100%;'"
        class="item"
      ></a>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  props:["banners"],
  data() {
    return {
    };
  }
};
</script>

<style scoped>
.banner {
  width: 3.48rem;
  margin:0.115rem auto 0.095rem;
}
.item {
  display: block;
  background-size: 100%;
  width: 3.48rem;
  height: 1.28rem;
}
</style>
